export enum Gender {
  None = 'None',
  Male = 'Male',
  Female = 'Female'
}
